import React, { ChangeEventHandler, forwardRef } from 'react';
import { makeCSS } from '../../../utils/makeCSS';
import { InputAdornment, TextField } from '@material-ui/core';
import { Icon } from '../../atoms/Icon';
import { SizeVariants } from '../../../theme/themes';

const useCss = makeCSS(({ theme }) => {
  return {
    root: {},
    searchIcon: {
      color: theme.color.background.secondary,
      alignSelf: 'center',
      paddingLeft: 0
    },
    searchBox: {
      //  background: theme.color.underlay['01'],
      display: 'flex',
      width: '100%'
    },
    withBorder: {
      border: `1px solid ${theme.color.background.secondary}`,
      borderRadius: theme.borderRadius.lg,
      '&:focus-within': {
        border: `${theme.color.background.primary} 1px solid`
      }
    },
    searchBoxText: {
      fontSize: '14px',
      lineHeight: '20px',
      // letterSpacing: '0.02em',
      color: 'rgba(255, 255, 255, 0.9)',
      textRendering: 'optimizeLegibility',
      MozOsxFontSmoothing: 'grayscale',
      WebkitFontSmoothing: 'antialiased',
      minHeight: 40,
      boxSizing: 'border-box'
    },
    multiline: {
      padding: 'inherit'
    },
    darkBG: {
      background: theme.color.underlay['01']
    }
  };
});

interface Props {
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  placeholder?: string;
  startAdornment?: JSX.Element | 'none';
  withBorder?: boolean;
  /** with dark backgroud color */
  dark?: boolean;
  multiline?: boolean;
  maxRows?: number;
}

const stopPropagation = (e) => e.stopPropagation();

export const SearchField = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const {
    value,
    onChange,
    placeholder,
    startAdornment,
    withBorder = true,
    dark = false,
    multiline = false,
    ...restProps
  } = props;

  const classes = useCss();

  return (
    <div
      className={`${classes.searchBox} ${withBorder ? classes.withBorder : ''
        } ${dark ? classes.darkBG : ''}`}
    >
      <TextField
        inputRef={ref}
        {...restProps}
        id="input-with-icon-search-field"
        placeholder={placeholder}
        onChange={onChange}
        fullWidth={true}
        value={value}
        onClick={stopPropagation}
        autoComplete="off"
        multiline={multiline}
        InputProps={{
          startAdornment: startAdornment !== 'none' && (
            <InputAdornment
              position="start"
              classes={{ root: classes.searchIcon }}
            >
              {startAdornment || (
                <span style={{ paddingLeft: 8 }}>
                  <Icon
                    icon="search"
                    size={SizeVariants.md}
                    color="dark"
                    colorVariant="03"
                  />
                </span>
              )}
            </InputAdornment>
          ),
          disableUnderline: true,
          className: classes.searchBoxText
        }}
        inputProps={{
          root: classes.searchBoxText,
          inputMultiline: classes.multiline
        }}
      />
    </div>
  );
});
